module.exports = __webpack_public_path__ + "static/media/undraw_progressive.fa52d744.svg";